import type {RouteRecordRaw} from 'vue-router';
import {SystemMessageType} from '@myparcel-frontend/types';

export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/Dashboard/Dashboard.vue'),
    meta: {
      feature: 'page.dashboard',
      permissions: ['checkUsername'],
      title: (t) => t('dashboard.title', 2),
      systemMessageType: SystemMessageType.DASHBOARD,
    },
    props: {
      message: 'lorum ipsum',
    },
  },
];
